// @flow
import {
  ActionCreator,
  buildCatchError,
  createReducer,
} from '../../../store/utils';
import {ofType} from 'redux-observable';
import {map, switchMap, debounceTime} from 'rxjs/operators';
import {getGAIntegrationApi, updateGAIntegrationApi} from './api';
import type {ReportRequest} from './api';

import type {ActionsObservable} from 'redux-observable';
import type {Action} from '../../../store/utils';

import type {StoreAnalyticsProvider} from '../../../entities';

export type ReportsAction = Action & {};

export type ReportsState = {
  trackingId?: string,
  saveSuccess?: boolean,
  isSaving?: boolean,
  error?: string,
  isFetchingGA?: boolean,
  gtmProvider?: StoreAnalyticsProvider,
};

export class FetchGAIntegration extends ActionCreator<ReportsAction> {}
export class FetchGAIntegrationSuccess extends ActionCreator<ReportsAction> {}
export class FetchGAIntegrationErrorFn extends ActionCreator<ReportsAction> {}

export class UpdateGAIntegration extends ActionCreator<ReportsAction> {}
export class UpdateGAIntegrationSuccess extends ActionCreator<ReportsAction> {}
export class UpdateGAIntegrationErrorFn extends ActionCreator<ReportsAction> {}

export class SetGTMId extends ActionCreator<ReportsAction> {}
export class DeleteGTMId extends ActionCreator<ReportsAction> {}

export const actions = {
  fetchGAIntegration: (payload: ReportsAction) =>
    new FetchGAIntegration(payload),
  updateGAIntegration: (payload: ReportsAction) =>
    new UpdateGAIntegration(payload),

  setGTMId: (gtmProvider: StoreAnalyticsProvider) =>
    new SetGTMId({
      gtmProvider,
    }),

  deleteGTMId: () => new DeleteGTMId(),
};
export const initialState: ReportsState = {};

export default createReducer<ReportsState>(initialState, {
  [FetchGAIntegration.type]: (state: ReportsState): ReportsState => ({
    ...state,
    isFetchingGA: true,
  }),
  [FetchGAIntegrationSuccess.type]: (
    state: ReportsState,
    action: ReportsAction
  ): ReportsState => ({
    ...state,
    isFetchingGA: false,
    error: undefined,
    trackingId: action.trackingId,
  }),
  [FetchGAIntegrationErrorFn.type]: (
    state: ReportsState,
    action: ReportsAction
  ): ReportsState => ({
    ...state,
    isFetchingGA: false,
    error: action.error,
  }),
  [UpdateGAIntegration.type]: (
    state: ReportsState,
    action: ReportsAction
  ): ReportsState => ({
    ...state,
    isSaving: true,
    saveSuccess: undefined,
    error: undefined,
  }),
  [UpdateGAIntegrationSuccess.type]: (
    state: ReportsState,
    action: ReportsAction
  ): ReportsState => {
    return {
      ...state,
      isSaving: undefined,
      saveSuccess: true,
      trackingId: action.trackingId,
    };
  },
  [UpdateGAIntegrationErrorFn.type]: (
    state: ReportsState,
    action: ReportsAction
  ): ReportsState => ({
    ...state,
    isSaving: undefined,
    saveSuccess: undefined,
    error: action.error,
  }),
  [SetGTMId.type]: (
    state: ReportsState,
    action: ReportsAction
  ): ReportsState => ({
    ...state,
    gtmProvider: action.gtmProvider,
  }),
  [DeleteGTMId.type]: (state: ReportsState): ReportsState => ({
    ...state,
    gtmProvider: undefined,
  }),
});

export const fetchGAIntegrationEpic = (action$: ActionsObservable) =>
  action$.pipe(
    ofType(FetchGAIntegration.type),
    debounceTime(250),
    switchMap(({couponId}: ReportsAction) =>
      getGAIntegrationApi().pipe(
        map(
          ({trackingId}: {trackingId: string}) =>
            new FetchGAIntegrationSuccess({trackingId})
        ),
        buildCatchError(FetchGAIntegrationErrorFn)
      )
    )
  );

export const updateGAIntegrationEpic = (action$: ActionsObservable) =>
  action$.pipe(
    ofType(UpdateGAIntegration.type),
    switchMap(({reportRequest}: {reportRequest: ReportRequest}) => {
      return updateGAIntegrationApi(reportRequest).pipe(
        map(
          ({trackingId}: {trackingId: string}) =>
            new UpdateGAIntegrationSuccess({trackingId})
        ),
        buildCatchError(UpdateGAIntegrationErrorFn, 'Error al actualizar.')
      );
    })
  );
